// pinia store - cartStore.js
import { defineStore } from 'pinia'

export const useCartStore = defineStore('cartStore', {
  state: () => ({
    showCartDropdown: false,
    // ...
  }),
  actions: {
    toggleCartDropdown(boolValue) {
      this.showCartDropdown = boolValue
    }
  }
})
